<template>
  <div class="list">
    <p>{{title}}</p>
    <textarea :class="{error: errors[name].hasError, saved: savedFields.hasOwnProperty(name) && !changed}" v-model="item[name]"
              @blur="isEmpty()" @keydown="removeError" cols="30" rows="10"></textarea>
    <div class="invalid_text" v-if="errors[name].hasError">{{errors[name].message}}</div>
  </div>
  <!--<div class="container_error" :class="{error: errors[name].hasError}">-->
  <!--<div class="list">{{title}}</div>-->
  <!--<textarea v-model="newFields[name]" @blur="isEmpty()"-->
  <!--@keydown="removeError" cols="30" rows="10"></textarea>-->
  <!--<div class="fail_text" v-if="errors[name].hasError">{{errors[name].message}}</div>-->
  <!--</div>-->
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapState} = createNamespacedHelpers('editPage')
  export default {
    props: ['title', 'name'],
    data() {
      return {
        changed: false
      }
    },
    computed: {
      ...mapState([
        'item',
        'errors',
        'savedFields'
      ])
    },
    methods: {
      ...mapMutations([
        'setError'
      ]),
      isEmpty () {
        if (!this.item[this.name] && !this.errors[this.name].isNullable) {
          this.setError({fieldId: this.name, flag: true})
        }
      },
      removeError () {
        this.changed = true
        if (!this.item[this.name]) this.setError({fieldId: this.name, flag: false})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .list {
    align-items: flex-start !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-form/new-items/TextArea.vue